/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useState, useEffect, useRef, ChangeEvent, useMemo } from 'react';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { ContentType, ContentStatusType, ContentTypeKey } from '../../../../../../../ResourcesRevised/types';
import ContentCards from '../../../../../../../ResourcesRevised/Components/Resuable/ContentCard';
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';
import { mapToContentItem } from './utils';
// Import types from content_graphql_types and the API function
import { ContentResponse, Playlist, ContentType as GraphQLContentType, TimePeriod, ContentStatus } from '../../../../../../../actions/resource_graphql_actions/content_graphql_types';
import contentGraphQLApi from '../../../../../../../actions/resource_graphql_actions/content_graphql_api';
import { useSelector } from 'react-redux';
import { useScroll } from '../../../../../../../../libs/CustomHooks/useScroll';
import useResourceHelper from './useResourceHelper';
import { useSearchParams, useParams } from 'react-router-dom';
import useDidMountEffect from '../../../../../../../../libs/CustomHooks/UseDidMountEffect';
import ContentListContainer from './ContentListContainer';

// Extract the getContent and searchContent functions from the imported API
const { getContent, searchContent } = contentGraphQLApi;

interface PlaylistsCardsListProps {
	selectedItems: string[];
	handleCheckboxChange: (itemId: string, checked: boolean) => void;
	handleBulkSelectionUpdate: (ids: string[], add: boolean) => void;
	onCountUpdate: (count: number) => void;
	selectAll: boolean;
	showPath?: boolean;
	StatusVisible?: boolean;
	ContentView?: string;
	itemsPerView: number;
	onContentClick?: (contentType: string, contentId: string) => void;
	viewAll: boolean;
	handleViewAll?: (isViewAll: ContentTypeKey) => void;
	searchValue?: string;
}

// Interface for pagination state
interface PaginationState {
	total: number;
	page: number;
	limit: number;
	pages?: number;
}

const PlaylistsCardsList: React.FC<PlaylistsCardsListProps> = ({
	selectedItems,
	handleCheckboxChange,
	handleBulkSelectionUpdate,
	onCountUpdate,
	selectAll,
	showPath = false,
	StatusVisible = true,
	ContentView = 'grid',
	itemsPerView,
	onContentClick,
	viewAll,
	handleViewAll,
	searchValue
}) =>
{
	// Hooks must be called unconditionally and in the same order every render
	const params = useParams();
	const sessionCompanyId = useSelector((state: any) => state.mysession?.session?.companyId);
	const companyId = params?.companyId || sessionCompanyId;
	const { isAdminView } = useResourceHelper();

	// Fetch playlists with pagination
	const fetchPlaylists = async (filter: any) =>
	{
		try
		{
			let response;

			filter.from = isAdminView ? 'Configuration' as const : 'MyResource' as const;
			if (filter.filters?.status === 'PUBLISHED')
			{
				delete filter.filters.status;
			}
			if (searchValue && searchValue.trim() !== '')
			{
				filter.contentType = GraphQLContentType.PLAYLIST;
				response = await searchContent(companyId, searchValue.trim(), filter);
			}
			else
			{
				filter.filters.types = [ GraphQLContentType.PLAYLIST ];
				response = await getContent(companyId, filter);
			}

			if (response && response.data)
			{
				return response;
			}
		}
		catch (error)
		{
			console.error('Error fetching playlists:', error);
		}
	};

	return (
		<ContentListContainer
			selectedItems={selectedItems}
			handleCheckboxChange={handleCheckboxChange}
			getContentApi={fetchPlaylists}
			handleBulkSelectionUpdate={handleBulkSelectionUpdate}
			onCountUpdate={onCountUpdate}
			selectAll={selectAll}
			viewAll={viewAll}
			handleViewAll={handleViewAll}
			searchValue={searchValue}
			type='Playlists'
		>
			<ContentCards
				section='playlists'
				type='Playlists'
			/>
		</ContentListContainer>
	);
};

// Add display name
PlaylistsCardsList.displayName = 'PlaylistsCardsList';

export default PlaylistsCardsList;